var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInboxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.28108 1.68672C4.55519 1.23732 4.94021 0.865923 5.39919 0.608176C5.85817 0.35043 6.37569 0.214985 6.90209 0.214844H17.098C18.1689 0.214844 19.1617 0.773217 19.719 1.68672L22.8771 7.96171L21.4477 8.83389L18.2895 2.55889C18.1649 2.35461 17.9899 2.1858 17.7812 2.06866C17.5725 1.95152 17.3373 1.88998 17.098 1.88996H6.90209C6.41518 1.88996 5.96402 2.14346 5.71052 2.55889L2.55236 8.83389L1.12292 7.96171L4.28108 1.68672Z",
    fill: "#6F767E",
    stroke: "#6F767E",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.00012 8.39615C1.00012 8.17402 1.08836 7.96098 1.24544 7.80391C1.40251 7.64684 1.61555 7.55859 1.83768 7.55859H7.59451C7.94852 7.55859 8.26456 7.78194 8.38405 8.11585C8.65002 8.86219 9.14039 9.50797 9.78789 9.96461C10.4354 10.4212 11.2083 10.6664 12.0006 10.6664C12.793 10.6664 13.5659 10.4212 14.2134 9.96461C14.8609 9.50797 15.3512 8.86219 15.6172 8.11585C15.6752 7.95317 15.7822 7.81241 15.9233 7.71285C16.0644 7.61329 16.2329 7.5598 16.4056 7.55971H22.1625C22.3846 7.55971 22.5976 7.64795 22.7547 7.80503C22.9118 7.9621 23 8.17514 23 8.39727V14.4199C23 15.2344 22.6765 16.0155 22.1005 16.5914C21.5246 17.1674 20.7435 17.4909 19.929 17.4909H4.07117C3.25668 17.4909 2.47555 17.1674 1.89961 16.5914C1.32368 16.0155 1.00012 15.2344 1.00012 14.4199V8.39615ZM2.67524 9.23371V14.4199C2.67524 15.1904 3.30062 15.8158 4.07117 15.8158H19.929C20.6995 15.8158 21.3249 15.1904 21.3249 14.4199V9.23371H16.9607C16.5092 10.1654 15.8044 10.9512 14.9271 11.501C14.0498 12.0507 13.0354 12.3423 12.0001 12.3423C10.9647 12.3423 9.95032 12.0507 9.07301 11.501C8.19569 10.9512 7.49095 10.1654 7.03948 9.23371H2.67524Z",
    fill: "#6F767E",
    stroke: "#6F767E",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInboxIcon);
export default __webpack_public_path__ + "static/media/inbox_icon.a338f0bdc6f6a27a755991c9b45b12c6.svg";
export { ForwardRef as ReactComponent };